import { CircleMarker } from 'react-leaflet';
import type { RiverDeviceMarker } from './river-geojson';

interface RiverDeviceMarkerLayerProps {
  devices: RiverDeviceMarker[];
  selectedDeviceIds: string[];
  onSelectDevice: (device: RiverDeviceMarker) => void;
}

export function RiverDeviceMarkerLayer({
  devices,
  selectedDeviceIds,
  onSelectDevice,
}: RiverDeviceMarkerLayerProps) {
  return (
    <>
      {devices.map((device) => {
        const [lng, lat] = device.coordinate;
        const selected = selectedDeviceIds.includes(device.id);

        return (
          <CircleMarker
            key={device.id}
            center={[lat, lng]}
            radius={selected ? 10 : 8}
            eventHandlers={{
              click: () => onSelectDevice(device),
            }}
            pathOptions={{
              color: selected ? '#14532d' : '#065f46',
              fillColor: selected ? '#86efac' : '#34d399',
              fillOpacity: 0.95,
              weight: selected ? 4 : 2.5,
            }}
          />
        );
      })}
    </>
  );
}
